import { render, staticRenderFns } from "./EditSpecimen.vue?vue&type=template&id=d3c85bc4&scoped=true"
import script from "./EditSpecimen.vue?vue&type=script&lang=js"
export * from "./EditSpecimen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c85bc4",
  null
  
)

export default component.exports